export default function Machines()
{
    return(
        <div className='Page'>
            <h1>Machines</h1>
        </div>
    )
}